import { KLAYO_COLORS } from '@/themes';
import { Skeleton, Stack } from '@mui/material';
import { Component } from 'react';
import { Paper } from './Paper';

export class StatCard extends Component<any, any> {
  render() {
    const {
      sx,
      icon,
      title,
      stat,
      statStyle,
      loading,
      direction = 'row',
      wrapTextProps = {},
      selected = false,
      hasActiveSelection = false,
      onClick,
    } = this.props;

    const dimmed = hasActiveSelection && !selected;
    const titleColor = dimmed ? KLAYO_COLORS.GreyGR400 : KLAYO_COLORS.GreyGR500;
    const statColor = dimmed ? KLAYO_COLORS.GreyGR400 : KLAYO_COLORS.GreyGR900;

    return (
      <Paper
        className='klayo-statcard'
        padding='24px'
        sx={{
          ...sx,
          cursor: onClick ? 'pointer' : undefined,
          border: selected ? `2px solid ${KLAYO_COLORS.NeonBlueNB500}` : undefined,
        }}
        onClick={onClick}
      >
        <Stack direction={direction} spacing={2}>
          {icon && <div className='klayo-statcard_badge'>{icon}</div>}
          <Stack direction={'column'} {...wrapTextProps}>
            {title && (
              <div
                className='klayo-statcard_title'
                style={{ color: titleColor }}
              >
                {title}
              </div>
            )}
            {!isNaN(stat) && (
              <div
                className='klayo-statcard_stat'
                style={{ color: statColor, ...statStyle }}
              >
                {loading ? <Skeleton width='32px' /> : stat}
              </div>
            )}
          </Stack>
        </Stack>
      </Paper>
    );
  }
}
